import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function contactFormSubmittedSuccess() {
  return { type: types.CONTACT_MESSAGE_SUCCESS };
}

export function sendContactForm(contactFormData) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'contact';
    return axios
      .post(url, {
        name: contactFormData.name,
        email: contactFormData.email,
        phone: contactFormData.phone,
        message: contactFormData.message,
      })
      .then((response) => {
        dispatch(contactFormSubmittedSuccess());
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/contactActions.js